module.exports = __webpack_public_path__ + "static/media/settings-icon.7cfed434.svg";